import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const wrapperStyles = () => css`
  display: inline;
  font-weight: bold;
`

export const Wrapper = styled.div(wrapperStyles)
